import { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import CartContext from '../../store/cart-context';

import classes from './styles/Cart.module.css';

import Price from '../UI/Price';
import Modal from '../UI/Modal';
import FoodItem from '../Food/FoodItem/FoodItem';

const Cart = ({ onHideCart }) => {
  const navigate = useNavigate();
  const cartContext = useContext(CartContext);
  // console.log(cartContext.items);

  const cartItems = (
    <ul className={classes.cartItems}>
      {cartContext.items.length <= 0 && (
        <li>No tenes productos agregados!</li>
      )}
      {cartContext.items.map((item, id) => {
        return <FoodItem 
          key={id}
          id={item.id}
          name={item.name}
          description={item.selectedSubItems.map(v => v.name).join(' - ')}
          price={item.price}
          showQtySelector={false}
        />
      })}
    </ul>
  );

  const havePromoItems = cartContext.items.filter(x => x?.promo || false).length > 0;

  const handleClick = () => {
    onHideCart();
    navigate('/order');
  }

  return (
    <Modal onClose={onHideCart}>
      {cartItems}
      
      {!havePromoItems && (
        <div className={classes.total}>
          <span>Total</span>
          <span><Price value={cartContext.items.reduce((curr, i) => curr + parseInt(i.price), 0)} /></span>
        </div>
      )}

      {havePromoItems && (
        <>
          <div className={classes.total}>
            <span>Subtotal</span>
            <span><Price value={cartContext.items.reduce((curr, i) => curr + parseInt(i.price), 0)} /></span>
          </div>

          {cartContext.items.filter(x => x?.promo || false).length > 0 && (
            <div className={classes.discount}>
              <span>Descuento</span>
              <span>- <Price value={cartContext.items.reduce((curr, i) => { 
                if( i?.promo )
                  return curr + parseInt(i.price * (parseInt(i.promo.discount) / 100) );
                else return curr;
              }, 0)} /></span>
            </div>
          )}

          <div className={classes.total}>
            <span>Total</span>
            <span><Price value={cartContext.items.reduce((curr, i) => { 
              if(i?.promo)
                return curr + parseInt(i.price * (parseInt(i.promo.discount) / 100)); 
              else
                return curr + parseInt(i.price); 
            }, 0)} /></span>
          </div>
        </>
      )}

      <div className={classes.actions}>
        <button className="btn bg-white" onClick={onHideCart}>
          Cerrar
        </button>
        {cartContext.items.length > 0 && (
          <button className="btn btn-success rounded-pill" onClick={handleClick}>Realizar Pedido</button>
        )}
      </div>
    </Modal>
  );
};

export default Cart;
